import { render, staticRenderFns } from "./StickyNote.vue?vue&type=template&id=7a517046"
import script from "./StickyNote.vue?vue&type=script&lang=js"
export * from "./StickyNote.vue?vue&type=script&lang=js"
import style0 from "./StickyNote.vue?vue&type=style&index=0&id=7a517046&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports